import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export default function TenantInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [total, setTotal] = useState(0);
  const fetch = async () => { const r = await api.get('/tenant/invoices'); setInvoices(r.data.invoices); setTotal(r.data.total); };
  useEffect(() => { fetch(); }, []);
  const fmt = (v) => new Intl.NumberFormat('id-ID').format(v || 0);
  const updateStatus = async (id, status) => { await api.put(`/tenant/invoices/${id}/status?status=${status}`); fetch(); };
  return (
    <div data-testid="tenant-invoices-page">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 mb-6" style={{ fontFamily: 'Plus Jakarta Sans' }}>Invoice ({total})</h1>
      <Card className="border-slate-200 shadow-sm"><CardContent className="p-0">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-slate-100">
            <th className="text-left py-3 px-4 text-slate-500 font-medium">No. Invoice</th>
            <th className="text-left py-3 px-4 text-slate-500 font-medium">Tipe</th>
            <th className="text-left py-3 px-4 text-slate-500 font-medium">Total</th>
            <th className="text-left py-3 px-4 text-slate-500 font-medium">Status</th>
            <th className="text-left py-3 px-4 text-slate-500 font-medium">Tanggal</th>
            <th className="text-right py-3 px-4 text-slate-500 font-medium">Aksi</th>
          </tr></thead>
          <tbody>
            {invoices.map(inv => (
              <tr key={inv.id} className="border-b border-slate-50 hover:bg-slate-50/50">
                <td className="py-3 px-4 font-mono text-xs">{inv.invoice_number}</td>
                <td className="py-3 px-4 capitalize">{inv.type}</td>
                <td className="py-3 px-4 font-medium">Rp {fmt(inv.total)}</td>
                <td className="py-3 px-4"><Badge variant="outline" className={inv.status === 'paid' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}>{inv.status}</Badge></td>
                <td className="py-3 px-4 text-xs text-slate-500">{new Date(inv.created_at).toLocaleDateString('id-ID')}</td>
                <td className="py-3 px-4 text-right">
                  {inv.status === 'unpaid' && <Button size="sm" variant="outline" onClick={() => updateStatus(inv.id, 'paid')} data-testid={`mark-paid-${inv.id}`}>Tandai Lunas</Button>}
                </td>
              </tr>
            ))}
            {!invoices.length && <tr><td colSpan={6} className="py-12 text-center text-slate-400">Belum ada invoice</td></tr>}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
